import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';

import RepeatIcon from '../../../../assets/icons/RepeatIcon';
import { colorsPalette } from '../../../../theme';
import useCardStyles from '../../styles';
import useStyles from './styles';

interface CardRepeatIconProps {
  wrapperClass?: string;
  iconClass?: string;
}

const CardRepeatIcon: React.FC<CardRepeatIconProps> = ({ wrapperClass, iconClass, ...rest }) => {
  const classes = { ...useStyles(), ...useCardStyles() };

  return (
    <Box className={cx(classes.iconWrapper, wrapperClass)} {...rest}>
      <RepeatIcon className={cx(classes.repeatIcon, iconClass)} color={colorsPalette.white} />
    </Box>
  );
};

export default CardRepeatIcon;
